import { CardPaymentForm } from 'components';
import ActionRequired from 'components/ActionRequired';
import AlternatingText from 'components/AlternatingText';

import ChangeToOpenBankingButton from './ChangeToOpenBankingButton';

import { useStatusDepositContext } from '../../context';

const StatusDepositCard: React.FunctionComponent = function () {
  const { job, subheading } = useStatusDepositContext();
  return (
    <div className="flex flex-col -mt-2">
      <div className="hidden md:flex flex-col">
        <ActionRequired />
      </div>
      <CardPaymentForm
        job={job}
        title="Pay deposit via Card"
        customHeading={
          <div className="mb-6 md:mb-8">
            <AlternatingText array={subheading} />
          </div>
        }
        showActionRequired={false}
      />
      <ChangeToOpenBankingButton />
    </div>
  );
};

export default StatusDepositCard;
